import { ChangeEvent, useMemo, useState } from 'react';
import { MappedVehicleType } from '../../types';

interface UseSearchesInterface {
  vehicles: MappedVehicleType[];
}

export default function useSearches({ vehicles }: UseSearchesInterface) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredVehicles = useMemo(() => vehicles?.filter((vehicle) => (
    vehicle.vehicleCode.toLowerCase().includes(searchTerm.toLowerCase())
  )), [searchTerm, vehicles]);

  function handleChangeSearchTerm(event: ChangeEvent<HTMLInputElement>) {
    setSearchTerm(event.target.value);
  }

  return {
    filteredVehicles,
    handleChangeSearchTerm,
    searchTerm,
  };
}
